import React from "react";

export const Layout: React.FC = (props) => {
    return (
        <div className="flex flex-1 flex-col bg-gradient-to-r from-[#070c19] to-[#172437]">
            {props.children}
        </div>
    );
};
